<template>
    <ToggleSimple @update:open="toggleOpen = $event">
        <template #toggle>
            <div class="left">
                <div v-if="$te('fields.bag.label')" class="toggle-text">
                    {{ $t('fields.bag.label') }}

                    <span v-if="isActive">
                        <div class="icon-check-dark"></div>
                    </span>
                </div>
                <div v-if="$te(`fields.bag.description`)" class="toggle-description">
                    {{ $t(`fields.bag.description`) }}
                </div>
            </div>
            <div class="right">
                <div v-if="isActive" class="reset" @click="resetSection">
                    <div class="icon-reset-pos"></div>
                </div>
                <div class="toggle-icon"></div>
            </div>
        </template>

        <template #content>
            <div class="bag-options" :class="cssClassOptions">
                <CustomCheckbox
                    v-model="localBag.gebruiksdoel"
                    inputKey="bag_gebruiksdoel"
                    @update:modelValue="onChanged('gebruiksdoel', $event)"
                    :options="gebruiksdoelOptions"
                    cssClass="custom-checkbox-type-5"
                    :showDescription="showDescriptions"
                />

                <!-- <CustomCheckbox
                    v-model="localBag.energielabel"
                    inputKey="bag_energielabel"
                    @update:modelValue="onChanged('energielabel', $event)"
                    :options="energielabelOptions"
                    cssClass="custom-checkbox-type-5"
                /> -->

                <CustomRangeSimple
                    inputKey="bag_bouwjaar"
                    :modelValue="localBag.bouwjaar"
                    :min="bouwjaarRange.min"
                    :max="bouwjaarRange.max"
                    :showLabel="true"
                    :showLabelMinMax="true"
                    :formatLabelRange="false"
                    :showDescription="showDescriptions"
                    @update:modelValue="onRangeChanged('bouwjaar', $event)"
                />

                <CustomRangeSimple
                    inputKey="bag_oppervlakte"
                    :modelValue="localBag.oppervlakte"
                    :min="oppervlakteRange.min"
                    :max="oppervlakteRange.max"
                    :showLabel="true"
                    :showLabelMinMax="true"
                    :formatLabelRange="true"
                    :showDescription="showDescriptions"
                    @update:modelValue="onRangeChanged('oppervlakte', $event)"
                />

                <!-- <CustomRangeSimple
                    inputKey="bag_grondoppervlakte"
                    :modelValue="localBag.grondoppervlakte"
                    :min="grondoppervlakteRange.min"
                    :max="grondoppervlakteRange.max"
                    :showLabel="true"
                    :showLabelMinMax="true"
                    :formatLabelRange="true"
                    @update:modelValue="onRangeChanged('grondoppervlakte', $event)"
                /> -->
            </div>
        </template>
    </ToggleSimple>
</template>

<script>
    import debounce from 'lodash/debounce';
    import ToggleSimple from '@/components/misc/ToggleSimple';
    import CustomRangeSimple from '@/components/inputs/CustomRangeSimple';
    import CustomCheckbox from '@/components/inputs/CustomCheckbox';

    export default {
        name: "OptionsBag",
        components: {
            ToggleSimple,
            CustomRangeSimple,
            CustomCheckbox
        },
        props: {
            modelValue: {
                type: Object,
                default: () => ({})
            },
            defaultVal: {
                type: Object,
                default: () => ({})
            },
            showDescriptions: {
                type: Boolean,
                default: true
            },
            cssClassOptions: {
                type: String,
                default: 'options-type-4'
            }
        },
        data() {
            return {
                name: 'bag',
                toggleOpen: false,
                localBag: {
                    gebruiksdoel: Array.isArray(this.modelValue?.gebruiksdoel) ? [...this.modelValue.gebruiksdoel] : [],
                    energielabel: Array.isArray(this.modelValue?.energielabel) ? [...this.modelValue.energielabel] : [],
                    bouwjaar: {
                        min: this.modelValue?.bouwjaar?.min !== null ? this.modelValue.bouwjaar.min : '',
                        max: this.modelValue?.bouwjaar?.max !== null ? this.modelValue.bouwjaar.max : ''
                    },
                    oppervlakte: {
                        min: this.modelValue?.oppervlakte?.min !== null ? this.modelValue.oppervlakte.min : '',
                        max: this.modelValue?.oppervlakte?.max !== null ? this.modelValue.oppervlakte.max : ''
                    },
                    grondoppervlakte: {
                        min: this.modelValue?.grondoppervlakte?.min !== null ? this.modelValue.grondoppervlakte.min : '',
                        max: this.modelValue?.grondoppervlakte?.max !== null ? this.modelValue.grondoppervlakte.max : ''
                    }
                },
                bouwjaarRange: {
                    min: 0,
                    max: new Date().getFullYear()
                },
                oppervlakteRange: {
                    min: 0,
                    max: 500000000
                },
                grondoppervlakteRange: {
                    min: 0,
                    max: 1000000000
                },
                gebruiksdoelOptions: [
                    { value: 'bijeenkomstfunctie', text: 'fields.bag_gebruiksdoel.option_bijeenkomstfunctie' },
                    { value: 'celfunctie', text: 'fields.bag_gebruiksdoel.option_celfunctie' },
                    { value: 'gezondheidszorgfunctie', text: 'fields.bag_gebruiksdoel.option_gezondheidszorgfunctie' },
                    { value: 'industriefunctie', text: 'fields.bag_gebruiksdoel.option_industriefunctie' },
                    { value: 'kantoorfunctie', text: 'fields.bag_gebruiksdoel.option_kantoorfunctie' },
                    { value: 'logiesfunctie', text: 'fields.bag_gebruiksdoel.option_logiesfunctie' },
                    { value: 'onderwijsfunctie', text: 'fields.bag_gebruiksdoel.option_onderwijsfunctie' },
                    { value: 'sportfunctie', text: 'fields.bag_gebruiksdoel.option_sportfunctie' },
                    { value: 'winkelfunctie', text: 'fields.bag_gebruiksdoel.option_winkelfunctie' },
                    { value: 'woonfunctie', text: 'fields.bag_gebruiksdoel.option_woonfunctie' }
                ],
                energielabelOptions: [
                    { value: 'A', text: 'A', noTranslate: true },
                    { value: 'B', text: 'B', noTranslate: true },
                    { value: 'C', text: 'C', noTranslate: true },
                    { value: 'D', text: 'D', noTranslate: true },
                    { value: 'E', text: 'E', noTranslate: true },
                    { value: 'F', text: 'F', noTranslate: true },
                    { value: 'G', text: 'G', noTranslate: true }
                ]
            };
        },
        computed: {
            isActive() {
                return JSON.stringify(this.modelValue) !== JSON.stringify(this.defaultVal);
            }
        },
        watch: {
            modelValue: {
                handler(newVal) {
                    if (newVal) {
                        this.localBag = {
                            gebruiksdoel: Array.isArray(newVal.gebruiksdoel) ? [...newVal.gebruiksdoel] : [],
                            energielabel: Array.isArray(newVal.energielabel) ? [...newVal.energielabel] : [],
                            bouwjaar: {
                                min: newVal.bouwjaar?.min !== null ? newVal.bouwjaar.min : '',
                                max: newVal.bouwjaar?.max !== null ? newVal.bouwjaar.max : ''
                            },
                            oppervlakte: {
                                min: newVal.oppervlakte?.min !== null ? newVal.oppervlakte.min : '',
                                max: newVal.oppervlakte?.max !== null ? newVal.oppervlakte.max : ''
                            },
                            grondoppervlakte: {
                                min: newVal.grondoppervlakte?.min !== null ? newVal.grondoppervlakte.min : '',
                                max: newVal.grondoppervlakte?.max !== null ? newVal.grondoppervlakte.max : ''
                            }
                        };
                    }
                },
                deep: true
            }
        },
        methods: {
            resetSection(event = null) {
                if (event) {
                    event.stopPropagation();
                }
                
                this.localBag = {
                    gebruiksdoel: [],
                    energielabel: [],
                    bouwjaar: { min: '', max: '' },
                    oppervlakte: { min: '', max: '' },
                    grondoppervlakte: { min: '', max: '' }
                };
                
                this.$emit('update:modelValue', {
                    ...this.defaultVal,
                    gebruiksdoel: [],
                    energielabel: [],
                    bouwjaar: { min: null, max: null },
                    oppervlakte: { min: null, max: null },
                    grondoppervlakte: { min: null, max: null }
                });
            },
            onChanged(field, value) {
                this.localBag[field] = value;
                this.emitUpdate();
            },
            onRangeChanged(field, value) {
                const { min, max } = value;
                this.localBag[field] = { min, max };
                
                const rangeConfig = field === 'bouwjaar' ? this.bouwjaarRange : 
                                   field === 'oppervlakte' ? this.oppervlakteRange : 
                                   this.grondoppervlakteRange;
                
                if ((min === '' || min < 1 || min < rangeConfig.min) && (max === '' || max < 1 || max > rangeConfig.max)) {
                    this.debouncedUpdateRange(field, { min: null, max: null });
                } else {
                    const newRange = {
                        min: min === '' || min < 1 || min < rangeConfig.min ? null : Number(min),
                        max: max === '' || max < 1 || max > rangeConfig.max ? null : Number(max)
                    };
                    
                    this.debouncedUpdateRange(field, newRange);
                }
            },
            emitUpdate() {
                const updatedBag = {
                    ...this.modelValue,
                    gebruiksdoel: this.localBag.gebruiksdoel || [],
                    energielabel: this.localBag.energielabel || []
                };
                
                this.$emit('update:modelValue', updatedBag);
            },
        },
        mounted() {
            this.debouncedUpdateRange = debounce(function(field, value) {
                const updatedBag = { ...this.modelValue };
                updatedBag[field] = value;
                this.$emit('update:modelValue', updatedBag);
            }.bind(this), 300);
        }
    }
</script>